import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-840fbbd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 mt-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "reasons-header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "reasons-header_title" }, "Reasons"),
  /*#__PURE__*/_createElementVNode("h2", { class: "reasons-header_subtitle" }, "TO INVEST IN GABON"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "reasons-header_image",
    src: "/media/platforms/gabon/back-ground.png"
  })
], -1))
const _hoisted_3 = { class: "reasons-content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<p class=\"reasons-content_description\" data-v-840fbbd4> In its quest to diversify and transform its economy, Gabon has made private investment a key lever for increasing investment in its territory. </p><p class=\"reasons-content_description\" data-v-840fbbd4> This virtual dealroom initiative aims to encourage private investors focused on the African continent to seize the many business opportunities in Gabon. Access to the platform provides investors with reliable and up-to-date information on various investment projects from the government and the private sector. </p><p class=\"reasons-content_description\" data-v-840fbbd4> The project portfolio covers a wide range of priority sectors: energy, health, education and productive sectors such as timber, fisheries, agriculture and services. </p><p class=\"reasons-content_description\" data-v-840fbbd4> This virtual dealroom initiative is part of the Transformation Acceleration Plan (PAT), a three-year program aimed to revive Gabon&#39;s economy. Estimated at about 6 billion dollars, 2/3 of the budget is/will be financed by the private sector through the mobilisation of foreign and domestic direct investments as well as public-private partnerships. </p><h3 class=\"reasons-content_innertitle mt-10\" data-v-840fbbd4> You might want to learn more about the improvements that have been made </h3>", 5)
const _hoisted_9 = { class: "navigation-menu" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navigation-menu_line" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navigation-menu_line" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          class: "navigation-menu_dot",
          "active-class": "navigation-menu_active",
          to: { name: 'reasons-1' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("1")
          ]),
          _: 1
        }),
        _hoisted_10,
        _createVNode(_component_router_link, {
          class: "navigation-menu_dot",
          "active-class": "navigation-menu_active",
          to: { name: 'reasons-2' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("2")
          ]),
          _: 1
        }),
        _hoisted_11,
        _createVNode(_component_router_link, {
          class: "navigation-menu_dot",
          "active-class": "navigation-menu_active",
          to: { name: 'reasons-3' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("3")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}